export enum AppointmentStatus {
    APPOINTMENT_PASSED = 'APPOINTMENT_PASSED',
    APPOINTMENT_SCHEDULED = 'APPOINTMENT_SCHEDULED',
    APPOINTMENT_CONFIRM = 'APPOINTMENT_CONFIRM',
    APPOINTMENT_NOT_FOUND = 'APPOINTMENT_NOT_FOUND',
}
